import api from '../api';

const getClientsList = async (params) => {
  const { data } = await api.get(`api/clients`, {
    params,
  });
  return data;
};

const getClientsAddress = async (clientIdParams) => {
  const params = {
    id: clientIdParams.clientId,
  };
  const { data } = await api.get(`api/clients/${clientIdParams.clientId}`, { params });
  return data;
};

const getClientInfoByEmail = async (email) => {
  const params = { email: email };

  const { data } = await api.get(`api/address/billing`);
  return data;
};

const getClientsStoreItems = async (params) => {
  try {
    const { data } = await api.get('/api/clients/sku', { params });
    return data;
  } catch (error) {
    throw error;
  }
};

const ClientsService = {
  getClientsList,
  getClientInfoByEmail,
  getClientsAddress,
  getClientsStoreItems,
};

export default ClientsService;
